export default {
  print: {
    printer: {
      addDevice: 'Add Print Device',
      editDevice: 'Edit Print Device',
      printDevice: 'Print Device',
      deviceName: 'Device Name',
      terminalNo: 'Terminal No.',
      belongStore: 'Store',
      storeName: 'Store Name',
      bindDevice: 'Bound Device',
      deviceSerialNo: 'Device Serial No.',
      deviceSerialNoPlaceholder: 'Enter device serial number/vendor device number',
      driverType: 'Driver Type',
      paperWidth: 'Paper Width',
      deviceStatus: 'Device Status',
      onlineStatus: 'Online Status',
      updateTime: 'Updated At',
      remark: 'Remarks',
      selectStore: 'Select a store',
      enterDeviceName: 'Enter print device name',
      selectBelongStore: 'Select a store',
      selectBindDevice: 'Select a device to bind',
      enterDeviceSerialNo: 'Enter device serial number',
      selectDriverType: 'Select a driver type',
      enterPaperWidth: 'Enter paper width',
      localEscPos: 'Local ESC/POS',
      localTspl: 'Local TSPL',
      localSystemDriver: 'Local System Driver',
      feieCloud: 'Feie Cloud',
      yilianCloud: 'Yilian Cloud',
      sunmiCloud: 'SUNMI Cloud',
      enabled: 'Enabled',
      disabled: 'Disabled',
      online: 'Online',
      offline: 'Offline',
      editSuccess: 'Updated successfully',
      addSuccess: 'Added successfully',
      deleteSuccess: 'Deleted successfully',
      deleteConfirmTitle: 'Delete Confirmation',
      deleteConfirm: 'Delete print device “{name}”?',
      statusConfirmTitle: '{action} Confirmation',
      statusConfirm: '{action} print device “{name}”?',
      statusSuccess: '{action} successfully',
    },

    rules: {
      headRuleLibrary: 'Head Office Rule Library',
      shopPrintRules: 'Store Print Rules',
      newRule: 'New Rule',
      editRule: 'Edit Rule',
      ruleName: 'Rule Name',
      keywordPlaceholder: 'Rule name / applicable source',
      systemDefault: 'System Default',
      copy: 'Copy',
      issue: 'Issue',
      noRules: 'No print rules',
      loading: 'Loading...',
      noMore: 'No more data',
      viewRules: 'View Rules',
      basicInfo: 'Basic Information',
      printerType: 'Printer Type',
      localPrinter: 'Local Printer',
      cloudPrinter: 'Cloud Printer',
      allSourcePrint: 'Print for All Sources',
      yes: 'Yes',
      no: 'No',
      operationSource: 'Operation Source',
      printScene: 'Print Scene',
      ruleStatus: 'Rule Status',
      whetherEnabled: 'Enabled',
      enabled: 'Enabled',
      enable: 'Enable',
      disabled: 'Disabled',
      ruleDescription: 'Rule Description',
      enterRuleName: 'Enter rule name',
      selectPrinterType: 'Select printer type',
      selectAllSourcePrint: 'Select whether to print for all sources',
      selectOperationSource: 'Select operation source',
      selectPrintScene: 'Select print scene',
      enterRuleDescription: 'Enter rule description',
      issueStores: 'Issue to Stores',
      issueTip: 'Select stores to receive this rule. The rule will be synchronized to the selected stores.',
      selectedStores: '{count} stores selected',
      confirmIssue: 'Confirm Issue',
      viewRule: 'View Rules',
      storePrint: 'Store Printing',
      storeCode: 'Store Code',
      storeName: 'Store Name',
      storeAddress: 'Store Address',
      contact: 'Contact',
      contactPhone: 'Contact Phone',
      printCount: 'Print {count} copies',
      noPrint: 'Do Not Print',
      allSources: 'All Sources',
      specifiedSources: 'Specified Sources',
      listSeparator: ', ',
      unnamedRule: 'Unnamed Rule',
      currentStore: 'Current Store',
      copyName: '{name} Copy',
      saveSuccess: 'Saved successfully',
      addSuccess: 'Added successfully',
      deleteConfirmTitle: 'Delete Confirmation',
      deleteConfirm: 'Delete print rule “{name}”?',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete. Please try again later.',
      selectIssueStore: 'Select stores to issue to',
      issueSuccess: 'Issued successfully',
    },
  },
};
